<script lang="ts">
  import css from '../../../css/comments.pcss.json'
  import { getContext } from "svelte";
  import type { Writable } from "svelte/store";
  import type { CommentsStateType } from "./MaterialComments.svelte";

  export let level: {
    id: number | string,
    parentId: number | string,
    hasLaterSiblings: boolean,
    hasChildren: boolean,
    hideCurrent?: boolean,
    shortHeight?: boolean
  }
  export let isCurrentLevel: boolean
  export let i: number

  const state: Writable<CommentsStateType> = getContext('comments')

  let currentClasses = [css['comment__lines__line__current']]
  let topClasses = [css['comment__lines__line__top']]
  let bottomClasses = [css['comment__lines__line']]
  let childrenClasses = [css['comment__lines__line__children']]
  const leftPx = i * 20 + 10

  $: {
    currentClasses = [css['comment__lines__line__current']]
    topClasses = [css['comment__lines__line__top']]
    bottomClasses = [css['comment__lines__line']]
    childrenClasses = [css['comment__lines__line__children']]
    if (level.hasLaterSiblings) {
      currentClasses.push(css['comment__lines__line__current--has-sibling'])
      topClasses.push(css['comment__lines__line__top--has-sibling'])
    }

    if ($state.highlightedParentId === level.parentId && (isCurrentLevel ? $state.highlightedId >= level.id : $state.highlightedId > level.id)) {
      topClasses.push(css['line--highlighted'])
    }
    if ($state.highlightedId === level.id) {
      currentClasses.push(css['line--highlighted'])
    } else if ($state.highlightedParentId === level.parentId && $state.highlightedId > level.id) {
      bottomClasses.push(css['line--highlighted'])
    }

    if ($state.highlightedParentId === level.id) {
      childrenClasses.push(css['line--highlighted'])
    }
  }
</script>

{#if level.hasLaterSiblings || (isCurrentLevel && !level.hideCurrent)}
    <div
        class={css['comment__lines__level']}
        data-level={i + 1}
        data-id={level.id}
        data-pid={level.parentId}
        style={`--line-left: ${leftPx}px`}
    >
        <div class={topClasses.join(' ')}></div>
        {#if level.hasLaterSiblings}
            <div class={bottomClasses.join(' ')}></div>
        {/if}
        {#if isCurrentLevel && !level.hideCurrent}
            <div class={currentClasses.join(' ')}></div>
        {/if}
        {#if isCurrentLevel && level.hasChildren}
            <div class={childrenClasses.join(' ')}></div>
        {/if}
    </div>
{/if}
